export default "__VITE_ASSET__1574623c__"